import React from 'react';

import { Paper } from '@material-ui/core';

import { FormikValues } from 'formik';

import { useStyles } from '../../../Themable.hooks';
import {
    usePreviewTask,
    useSelectedTaskId,
    useTasksMode,
} from '../../../../../state/ui/planning/tasks/index.hooks';
import {
    enterAddExternalLinkage,
    enterAddLocationMode,
} from '../../../../../state/ui/planning/tasks';
import { IReport } from '../../../../../state/types';
import {
    hideTopDialog,
    showTaskModificationDialog,
} from '../../../../../state/ui/dialog';
import { useSelectedRoute } from '../../../../../state/ui/planning/routes/index.hooks';
import { storeForm } from '../../../../../state/ui/forms';

import { useAppDispatch, useToolkitDispatch } from '../../../../../hooks';
import { getRouteAssigned } from '../../../utils';

import { PlanningExternalLinkages } from './PlanningTaskPreview/PlanningExternalLinkages';
import PlanningTaskLocationForm from './PlanningTaskLocationForm';
import TaskPreview from '../../../../../features/TaskForm/components/TaskPreview';
import ReportPreview from '../../../../../components/report/ReportPreview';

interface IOwnProps {
    handleClearTask: () => void;
    refetchGridsData: () => void;
}
const PlanningTaskPane = ({ handleClearTask, refetchGridsData }: IOwnProps) => {
    const classes = useStyles();
    const toolkitDispatch = useToolkitDispatch();
    const mode = useTasksMode();
    const dispatch = useAppDispatch();
    const taskId = useSelectedTaskId();
    const route = useSelectedRoute();
    const task = usePreviewTask();
    const routeAssigned = getRouteAssigned(route);

    const renderRightCustomControls = () => {
        return <></>;
    };
    const handleAddLocation = (values: FormikValues) => {
        dispatch(storeForm({ form: values, type: 'task' }));
        dispatch(hideTopDialog());
        toolkitDispatch(enterAddLocationMode());
    };

    const addActionHandler = (report: IReport) => {
        toolkitDispatch(enterAddExternalLinkage(report._meta?.actions?.add));
    };

    const handleChangeMode = () => {
        task?.id &&
            dispatch(
                showTaskModificationDialog({
                    taskId: task._meta.header.task.id,
                    routeAssigned,
                    onSuccess: refetchGridsData,
                    handleAddLocation,
                    mode: 'edit',
                })
            );
    };
    const renderPane = () => {
        switch (mode) {
            case 'preview':
                return (
                    <TaskPreview
                        task={task}
                        onClose={handleClearTask}
                        rightControls={renderRightCustomControls}
                        handleChangeMode={handleChangeMode}
                        pane={{
                            elementId: String(taskId),
                            elementCollectionName: 'tasks',
                        }}
                        usePlanningMode
                        refetchGridsData={refetchGridsData}
                        handleAddLocation={handleAddLocation}
                        reportChildren={
                            <ReportPreview
                                reports={task?.reports || null}
                                addActionHandler={addActionHandler}
                            />
                        }
                    />
                );

            case 'externalLinkage':
                return <PlanningExternalLinkages />;
            case 'addLocation':
                return <PlanningTaskLocationForm />;
            default:
                return;
        }
    };
    return (
        <Paper className={classes.formPane}>
            <div className={classes.wrapper}>{renderPane()}</div>
        </Paper>
    );
};

export default PlanningTaskPane;
